import { Step } from "./Step";

interface ProgressStepsProps {
  currentStep: number;
  totalSteps: number;
}

type Status = "complete" | "current" | "incomplete";

const getStatus = (currentStep: number, stepNumber: number): Status => {
  if (stepNumber < currentStep) {
    return "complete";
  }

  if (stepNumber === currentStep) {
    return "current";
  }

  return "incomplete";
};

export const ProgressSteps = ({
  currentStep,
  totalSteps,
}: ProgressStepsProps) => {
  const steps = Array.from({ length: totalSteps }, (_, i) => {
    const stepNumber = i + 1;
    const status = getStatus(currentStep, stepNumber);

    return <Step key={stepNumber} status={status} />;
  });

  return <ul className="flex w-full list-none">{steps}</ul>;
};

export default ProgressSteps;
